var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('v-overlay',{attrs:{"color":"white","light":"","absolute":"","opacity":"0.9"}},[_c('v-progress-circular',{attrs:{"color":"primary","indeterminate":"","size":"50"}})],1):_vm._e(),_c('div',{attrs:{"id":"chekin-container"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }